export const apiUrl = {
    baseUrl:"/api"
}